import {Grid, IconButton, Typography} from '@yandex-delivery/blocks'
import React, {useState} from 'react'
import type {ContentBarcodeItem} from 'src/api'
import {tagToUrl} from 'src/shared/utils'

import * as classes from './Barcode.classes'
import {BarcodeSvg} from './BarcodeSvg'
import {Modal} from './modal'
import {QRCodeSvg} from './QRCodeSvg'
import {getContentSections} from './utils'

type Props = {item: ContentBarcodeItem}

export function Barcode({item}: Props): React.ReactElement<Props> {
  const {action, barcode, barcode_type, orientation, subtitle, trail_image_tag} = item
  const contentSections = getContentSections(action)
  const [isModalOpened, setIsModalOpened] = useState(false)
  const openModal = setIsModalOpened.bind(null, true)
  const closeModal = setIsModalOpened.bind(null, false)

  return (
    <>
      <Grid container direction="column" size="s">
        <Grid item onPress={openModal}>
          {barcode_type === 'qr' ? (
            <QRCodeSvg text={barcode.barcode} vertical={orientation === 'vertical'} />
          ) : (
            <BarcodeSvg text={barcode.barcode} vertical={orientation === 'vertical'} />
          )}
        </Grid>
        {subtitle || trail_image_tag ? (
          <Grid alignItems="center" container item justify="space-between" size="xs">
            {subtitle && (
              <Grid item>
                <Typography color="minor" group="tight" thickness="regular" variant="caption1">
                  {subtitle}
                </Typography>
              </Grid>
            )}
            {trail_image_tag && (
              <Grid item>
                <IconButton onPress={openModal} size="xs" variant="ghost">
                  <img alt="" className={classes.trailImage} data-theme-invert src={tagToUrl(trail_image_tag)} />
                </IconButton>
              </Grid>
            )}
          </Grid>
        ) : null}
      </Grid>
      {isModalOpened && contentSections && <Modal contentSections={contentSections} onClose={closeModal} />}
    </>
  )
}
